import styled from '@emotion/styled';
import React from 'react';
import { ActionDefinition } from '../types';

export const ActionSummaryContainer = styled('div')((p) => ({
  padding: p.theme.spacing(2),
  borderRadius: p.theme.custom.border.radius(),
  border: `1px solid ${p.theme.custom.colors.gray.w200}`
}));

const ActionSummaryHeadingContainer = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: p.theme.spacing(1),
  gap: p.theme.spacing()
}));

export const ActionSummaryHeading = ({ def }: { def: ActionDefinition }) => (
  <ActionSummaryHeadingContainer>
    <img alt={''} width={16} height={16} src={def.iconSrc} />
    <div>{def.label}</div>
  </ActionSummaryHeadingContainer>
);

export const ActionSummaryBody = styled('div')((p) => ({
  color: p.theme.custom.colors.gray.w500
}));
